export enum InsideOutside {
	INSIDE = 'INSIDE',
	OUTSIDE = 'OUTSIDE',
}

export const INSIDE_OUTSIDE = [InsideOutside.INSIDE, InsideOutside.OUTSIDE];
